module.exports = __webpack_public_path__ + "static/media/oops.24794ce2.png";